import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: theme.size.sm,
    marginTop: '-0.5rem',
    borderTopLeftRadius: '1rem',
    borderTopRightRadius: '1rem',
    padding: '0.5rem 0',
    backgroundColor: '#FDB6B6',
    color: theme.palette.textAlt,

    '& > :not(:first-child)': {
      marginTop: '0.5rem'
    },

    [theme.breakpoints.down('lg')]: {
      marginBottom: '0.5rem'
    }
  },

  warning: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .icon': {
      marginRight: '0.5rem'
    }
  }
}))

export default useStyles
